import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import PageHeader from "../PageHeader";
import heroBackImage from "../images/hero/hero.webp";
import "../css/blogs.css";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

const resolveImageUrl = (src) => {
  if (!src) return "";
  if (src.startsWith("http://") || src.startsWith("https://")) return src;
  if (src.startsWith("/uploads/")) return `${API_BASE_URL}${src}`;
  return src;
};

const BlogDetailPage = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlog = async () => {
      setLoading(true);
      try {
        const res = await fetch(`${API_BASE_URL}/api/blogs/${slug}`);
        if (!res.ok) {
          setBlog(null);
        } else {
          const data = await res.json();
          setBlog(data.blog || null);
        }
      } catch {
        setBlog(null);
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [slug]);

  const breadcrumbLinks = [
    { label: "الرئيسية", path: "/" },
    { label: "المدونة", path: "/blogs" },
    { label: blog ? blog.title : "المقال", path: `/blogs/${slug}` },
  ];

  if (loading) {
    return (
      <>
        <PageHeader title="جاري تحميل المقال..." bgImage={heroBackImage} breadcrumbs={breadcrumbLinks} />
        <section className="blog-detail-section">
          <div className="container">
            <p className="blog-article">جاري تحميل تفاصيل المقال...</p>
          </div>
        </section>
      </>
    );
  }

  if (!blog) {
    return (
      <>
        <PageHeader title="المقال غير موجود" bgImage={heroBackImage} breadcrumbs={breadcrumbLinks} />
        <section className="blog-detail-section">
          <div className="container">
            <p className="blog-article">عذرًا، هذا المقال غير متاح.</p>
            <Link className="blog-back-link" to="/blogs">
              العودة إلى المدونة
            </Link>
          </div>
        </section>
      </>
    );
  }

  const sections = Array.isArray(blog.sections) ? blog.sections : [];
  const imageUrl = resolveImageUrl(blog.image);

  return (
    <>
      <PageHeader title="تفاصيل المقال" bgImage={heroBackImage} breadcrumbs={breadcrumbLinks} />

      <section className="blog-detail-section">
        <div className="container">
          <div className="blog-detail-hero">
            <div className="bg" style={{ backgroundImage: `url(${imageUrl})` }} />
            <div className="overlay" />
            <div className="content">
              <div className="blog-detail-meta">
                <span>{blog.category}</span>
                <span>•</span>
                <span>{blog.date}</span>
                <span>•</span>
                <span>{blog.readTime}</span>
              </div>
              <h1 className="blog-detail-title">{blog.title}</h1>
              <p
                style={{
                  margin: 0,
                  color: "rgba(255,255,255,0.85)",
                  fontFamily: "Cairo, sans-serif",
                }}
              >
                {blog.excerpt}
              </p>
            </div>
          </div>

          <article className="blog-article">
            {sections.map((section, idx) => (
              <div key={idx} className="blog-section">
                <h2 className="blog-section-title">{section.heading}</h2>
                {Array.isArray(section.paragraphs) &&
                  section.paragraphs.map((paragraph, pIdx) => (
                    <p key={pIdx}>{paragraph}</p>
                  ))}
              </div>
            ))}
          </article>

          <Link className="blog-back-link" to="/blogs">
            العودة إلى المدونة
          </Link>
        </div>
      </section>
    </>
  );
};

export default BlogDetailPage;

